import React from 'react';
import PropTypes from 'prop-types';
import RehypeReact from 'rehype-react';
import shuffle from 'lodash/shuffle';
import HeroBlock from 'marketing-website/components/modules/ContentBlocks/Hero';
import CopyBlock from 'marketing-website/components/modules/ContentBlocks/Copy';
import DoubleImageBlock from 'marketing-website/components/modules/ContentBlocks/DoubleImage';
import ReadMoreBlock from 'marketing-website/components/modules/ContentBlocks/ReadMore';
import QuoteBlock from 'marketing-website/components/modules/ContentBlocks/Quote';
import Page from 'marketing-website/components/modules/Page';
import ImageQuoteBlock from 'marketing-website/components/modules/ContentBlocks/ImageQuote';
import ImageStatsBlock from 'marketing-website/components/modules/ContentBlocks/ImageStats';
import SocialBlock from 'marketing-website/components/modules/ContentBlocks/Social';
import ImageBlock from 'marketing-website/components/modules/ContentBlocks/ImageBlock';
import Cta from 'marketing-website/components/modules/CtaStories';
import SmartLink from 'marketing-website/components/modules/SmartLink';

import metaData from 'marketing-website/data/metadata.js';
import customerStoriesItems from 'marketing-website/configs/customerStoriesItems';
import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck';

CaseStudiesDetailTemplate.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      htmlAst: PropTypes.object,
      frontmatter: PropTypes.shape({
        page: propTypeEmptyString,
        summary: propTypeEmptyString,
      }),
    }),
  }),
};

export default function CaseStudiesDetailTemplate({ data }) {
  if (!data || !data.markdownRemark) return null;

  const { markdownRemark } = data;
  const { frontmatter, htmlAst } = markdownRemark;
  const { page } = frontmatter;

  const componentsMap = {
    'copy-block': CopyBlock,
    'double-image-block': DoubleImageBlock,
    'hero-block': HeroBlock,
    'image-quote-block': ImageQuoteBlock,
    'quote-block': QuoteBlock,
    'stats-block': ImageStatsBlock,
    'image-block': ImageBlock,
    'smart-link': SmartLink,
  };

  const renderAst = new RehypeReact({
    createElement: React.createElement,
    components: componentsMap,
  }).Compiler;
  return (
    <Page
      title={metaData['case-studies'][page].title}
      meta={[
        {
          name: 'description',
          content: metaData['case-studies'][page].description,
        },
        { name: 'keywords', content: metaData['case-studies'][page].keywords },
      ]}
      header={{ isLight: false }}
      footer
    >
      {renderAst(htmlAst)}
      <SocialBlock />
      <ReadMoreBlock articles={shuffle(customerStoriesItems)} />
      <Cta />
    </Page>
  );
}

export const caseStudiesQuery = graphql`
  query CaseStudiesByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      htmlAst
      frontmatter {
        path
        page
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/caseStudies.js